import { type Contract, type Player } from '@prisma/client'
import { DateTime } from 'luxon'
import { CaptainStatus, ContractTypes } from '#app/constants'

export function formatContractType(contract: Pick<Contract, 'type'>) {
  switch (contract.type) {
    case ContractTypes.STANDARD:
      return 'Standard'
    case ContractTypes.TEN_DAY:
      return 'Short Term'
    case ContractTypes.PLAYOFF:
      return 'Short Term - Playoff'
    default:
      return 'Unknown'
  }
}

export function formatContractLength(contract: Pick<Contract, 'type' | 'length'>) {
  if (contract.type === ContractTypes.TEN_DAY) {
    return '10 days'
  } else if (contract.type === ContractTypes.PLAYOFF) {
    return '-'
  } else if (contract.length === 1) {
    return '1 year'
  } else {
    return `${contract.length} years`
  }
}

export function formatNationalityWithFlag(player: Pick<Player, 'nationality'>) {
  const flags: Record<string, string> = {
    Austria: '🇦🇹',
    Canada: '🇨🇦',
    China: '🇨🇳',
    Czechia: '🇨🇿',
    Finland: '🇫🇮',
    France: '🇫🇷',
    Germany: '🇩🇪',
    Hungary: '🇭🇺',
    Japan: '🇯🇵',
    Russia: '🇷🇺',
    Sweden: '🇸🇪',
    Switzerland: '🇨🇭',
    'United States': '🇺🇸',
  }

  const flag = flags[player.nationality] ?? ''
  return `${player.nationality} ${flag}`
}

export function formatPlayerHandedness(player: Pick<Player, 'shoots'>) {
  return player.shoots[0]
}

export function formatPlayerPosition(player: Pick<Player, 'position'>) {
  return player.position[0]
}

export function formatPlayerNameWithCaptaincy(player: Pick<Player, 'captain' | 'name'>) {
  switch (player.captain) {
    case CaptainStatus.CAPTAIN:
      return `${player.name} (C)`
    case CaptainStatus.ALTERNATE:
      return `${player.name} (A)`
    default:
      return player.name
  }
}

export function formatDate(date: Date) {
  return DateTime.fromJSDate(date).setZone('utc').toLocaleString(DateTime.DATE_MED)
}
